import { useContext } from "react";
import { CurrencyContext } from "./Context";

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyContext');
  }
  return context;
};
